import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getRepushActivationResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getRepushActivation', data);
        if (response.response.Status) {
            yield put(actions.getRepushActivationSuccess(response.response.Data));
        } else {
            yield put(actions.getRepushActivationFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getRepushActivationFailed(error));
    }
}

function* getRepushActivationRequestResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/repushActivationRequest', data);
        if (response.response.Status) {
            yield put(actions.updateRepushActivationSuccess(response.response.Message));
            yield put(actions.getRepushActivation(searchData));
        } else {
            yield put(actions.updateRepushActivationFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.updateRepushActivationFailed(error));
    }
}

function* getPrepaidiQActivationResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getPrepaidIQActivationForRepush', data);
        if (response.response.Status) {
            yield put(actions.getPrepaidIQActivationforRepushSuccess(response.response.Data));
        } else {
            yield put(actions.getPrepaidIQActivationforRepushFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getPrepaidIQActivationforRepushFailed(error));
    }
}


function* getPrePaidIQActivationRepushResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/repushPrepaidIQActivationRequest', data);
        if (response.response.Status) {
            yield put(actions.updatePrePaidIQActivationForRepushSuccess(response.response.Message));
            yield put(actions.getPrepaidIQActivationforRepush(searchData));
        } else {
            yield put(actions.updatePrePaidIQActivationForRepushFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.updatePrePaidIQActivationForRepushFailed(error));
    }
}
export default function* rootSaga() {
    yield all([takeEvery(actions.GET_REPUSH_ACTIVATION, getRepushActivationResponse)]);
    yield all([takeEvery(actions.UPDATE_REPUSH_ACTIVATION, getRepushActivationRequestResponse)]);
    yield all([takeEvery(actions.GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH, getPrepaidiQActivationResponse)]);
    yield all([takeEvery(actions.UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH, getPrePaidIQActivationRepushResponse)]);
}